require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./responsive-web-design-basic-html-and-html-5-declare-the-doctype-of-an-html-document.json") })
        }
      }, "path---responsive-web-design-basic-html-and-html-5-declare-the-doctype-of-an-html-document");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---responsive-web-design-basic-html-and-html-5-declare-the-doctype-of-an-html-document!./.cache/json/responsive-web-design-basic-html-and-html-5-declare-the-doctype-of-an-html-document.json
// module id = 2643
// module chunks = 231608221292675